import { render, staticRenderFns } from "./NotExist.vue?vue&type=template&id=53c8308d&"
import script from "./NotExist.vue?vue&type=script&lang=js&"
export * from "./NotExist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports